import {
  InformationSummarySection,
  ResultSummarySection,
} from '@exam-management/qconfig-generator-details';
import { Flex } from '@shared/components';

export default function QConfigGeneratorDetails() {
  return (
    <Flex
      sx={{
        padding: (theme) => theme.spacing(6),
        flexDirection: 'column',
        gap: (theme) => theme.spacing(6),
      }}
    >
      <InformationSummarySection />
      <ResultSummarySection />
    </Flex>
  );
}
